<script>
  export let data
  const isExternal = () => {
    let domain = data.href.match(/(?:[\w-]+\.)+[\w-]+/)
    domain = domain ? domain[0] : domain
    if (domain !== null && domain !== 'njerusalem.ru') return 'external_link'
    return ''
  }
</script>

<a href={data.href} target="_blank" class={isExternal(data)}>
  <slot></slot>
</a>

<style>
  a {
    display: inline;
  }
</style>
